import {Component, Input} from '@angular/core';

@Component({
  selector: 'mbnm-shop-detail-product-blocks',
  templateUrl: './shop-detail-product-blocks.component.html',
  styleUrl: './shop-detail-product-blocks.component.scss'
})
export class ShopDetailProductBlocksComponent {

  @Input()
  products:Array<any>;
}
